import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { Row, Col, Tooltip, Switch } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { ButtonOutlined } from "../../../Reusablecomponents/UIButtons/";
import { useNavigate } from "react-router-dom";
import { ActiontypeEnum, RTypeEnum } from "../../../Common/constant";

const Newbox = styled.div`
  .button_outlined {
    border-radius: 100%;
    outline: none;
    border: none;
    background-color: rgb(235, 247, 237);
    padding: 12px;
  }
  .button_outlined:hover {
    background-color: rgb(235, 247, 237) !important;
  }
  .parent_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .child_container {
    display: flex;
    align-items: center;
    width: 50%;
  }
  p {
    margin-bottom: 0px;
    font-weight: 400;
  }
  .container_three {
    width: 50%;
    display: flex;
    justify-content: flex-end;
    gap: 40px;
  }
  .kpi_container {
    display: flex;
    flex-wrap: wrap;
    background-color: white;
    width: 100%;
    margin-top: 30px;
    padding: 6px;
    border-radius: 0px 12px 0px 12px;
  }
  .kpi_container_one {
    background-color: white;
    width: 100%;
    margin-top: -1%;
    padding: 6px;
    border-radius: 8px;
  }
  .kpi_item_one {
    display: flex;
    flex-direction: column;
    margin: 15px 20px;
    width: 20%;
    gap: 40px;
  }
  .kpi_item {
    display: flex;
    flex-direction: column;
    margin: 15px 20px;
    width: 20%;
  }
  .kpi-label {
    color: rgb(133, 143, 167);
    padding: 4px;
  }
  .kpi-value {
    padding: 4px;
    word-wrap: break-word;
  }
`;

const KpiCustfied = ({
  setStateforpage,
  stateforpage,
  setIsView,
  handleToogle,
}) => {
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const createAllowed = useMemo(
    () => hasPermission("KPI", "C"),
    [reduxPermissions],
  );
  const navigate = useNavigate();

  const handlenavigateme = () => setIsView(false);

  const handlenavigateedit = () => navigate(`/administration/kpimaster`);
  function normalizeEditorValue(v) {
    if (v == null) return "";
    if (typeof v !== "string") return String(v);

    const s = v.trim();

    // Some editors return a JSON-stringified HTML string, e.g.
    // "\"<p>Hello</p>\\n<p>World</p>\\n\""
    // Normalize it back to a plain HTML string before stripping tags.
    if (
      (s.startsWith('"') && s.endsWith('"')) ||
      (s.startsWith("'") && s.endsWith("'"))
    ) {
      try {
        return JSON.parse(s);
      } catch {
        // ignore and fall through
      }
    }

    return s;
  }

  function stripHtml(html) {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }
  let removeTags;
  if (stateforpage?.MESSAGE === null) {
    removeTags = "";
  } else if (stateforpage?.MESSAGE) {
    removeTags = stateforpage?.MESSAGE.replace(/<\/?p>/g, "");
  }

  return (
    <>
      <Newbox>
        <Row gutter={16}>
          <Col xl={24} sm={24}>
            <div className="parent_container">
              <div className="child_container">
                <ButtonOutlined
                  onClick={handlenavigateme}
                  className="button_outlined"
                >
                  <LeftOutlined />
                </ButtonOutlined>
                <p>{stateforpage?.NAME}</p>
              </div>
              <div className="container_three">
                <label>
                  Status:
                  <span style={{ marginLeft: "15px" }}>
                    <Switch
                      disabled={!createAllowed}
                      checked={stateforpage?.ACTIVE}
                      onChange={() => {
                        setIsView(false);
                        handleToogle(stateforpage?.KPIID);
                      }}
                    />
                  </span>
                </label>
              </div>
            </div>
          </Col>
        </Row>
      </Newbox>

      <Newbox>
        <Row gutter={16}>
          <Col xl={24} sm={24}>
            <div className="kpi_container">
              <div className="kpi_item">
                <label className="kpi-label">KPI Name</label>
                <p className="kpi-value">{stateforpage?.NAME}</p>
              </div>

              <div className="kpi_item">
                <label className="kpi-label">Event Type</label>
                <p className="kpi-value">
                  {RTypeEnum.find((val) => val?.value === stateforpage?.EVTYPE)
                    ?.name || "--"}
                </p>
              </div>

              <div className="kpi_item">
                <label className="kpi-label">Action</label>
                <p className="kpi-value">
                  {ActiontypeEnum.find(
                    (val) => val?.value === stateforpage?.ACTION,
                  )?.name || "--"}
                </p>
              </div>

              <div className="kpi_item">
                <label className="kpi-label">Recipient Entity Type</label>
                <p className="kpi-value">
                  {stateforpage?.RECPTYPE?.replace(/^,/, "")
                    .split(",")
                    .map(
                      (code) =>
                        ({
                          C: "Consignor",
                          S: "Transporter",
                          Co: "Receiver",
                        })[code] || code,
                    )
                    .join(", ")}
                </p>
              </div>

              <div className="kpi_item">
                <label className="kpi-label">Minutes Less than</label>
                <p className="kpi-value">{stateforpage?.MINMINUTES || "--"}</p>
              </div>

              <div className="kpi_item">
                <label className="kpi-label">Minutes Exceed</label>
                <p className="kpi-value">{stateforpage?.MAXMINUTES || "--"}</p>
              </div>

              <div className="kpi_item">
                <label className="kpi-label">Vehicle Type</label>
                <p className="kpi-value">{stateforpage?.VEHTYPE || "--"}</p>
              </div>

              <div className="kpi_item">
                <label className="kpi-label">Info Only</label>
                <p className="kpi-value">Yes</p>
              </div>

              <div className="kpi_item">
                <label className="kpi-label">Auto Repeated</label>
                <p className="kpi-value">Yes</p>
              </div>
            </div>
          </Col>
          <Col xl={24} sm={24}>
            {removeTags || removeTags === "" ? (
              <div className="kpi_container_one">
                <div className="kpi_item_one">
                  <div>
                    <label className="kpi-label">Message</label>
                    <p className="kpi-value">
                      {stripHtml(normalizeEditorValue(stateforpage?.MESSAGE))}
                    </p>
                  </div>
                  {removeTags && (
                    <>
                      <div>
                        <p>Kind regards!!</p>
                      </div>
                      <div>
                        <p>Trackright Team</p>
                      </div>
                    </>
                  )}
                </div>
              </div>
            ) : (
              <></>
            )}
          </Col>
        </Row>
      </Newbox>
    </>
  );
};

export default KpiCustfied;
